export { SoftFunnelEntry, SoftFunnelEntryCard } from './SoftFunnelEntry';
